<template>
    <table v-if="datos && datos.ordenes">
      <thead>
        <tr>
          <th>Fecha creada</th>
          <th v-if="empresa.medirTiemposDeOrdenes">Fecha terminada</th>
          <th v-if="empresa.medirTiemposDeOrdenes">Tiempo</th>
          <th>Cliente</th>
          <th>Equipo</th>
          <th>SN</th>
          <th>Tipo</th>
          <th v-if="empresa.calcularCostos" class="ion-text-right">Costos</th>
          <th>Usuario</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(d,indice) in datos.ordenes" :key="indice">
          <td>{{d.fechaCreada | moment('MMM DD HH:mm')}}</td>
          <td v-if="empresa.medirTiemposDeOrdenes">{{d.fechaTerminada | moment('MMM DD HH:mm')}}</td>
          <td v-if="empresa.medirTiemposDeOrdenes">{{tiempo(d) | currency('')}}</td>
          <td>{{(d.cliente||{}).alias || (d.cliente||{}).nombre}}</td>
          <td>{{(d.equipo||{}).alias}} {{(d.equipo||{}).marca}} {{(d.equipo||{}).modelo}} </td>
          <td>{{d.equipo.sn}}</td>
          <td>{{d.tipoOrdenServicio}}</td>
          <td v-if="empresa.calcularCostos" class="ion-text-right">{{calcularCostos(d) | currency('')}}</td>
          <td>{{(d.autor||{}).alias || (d.autor||{}).nombre}}</td>
        </tr>
      </tbody>
    </table>
  </template>
<style>
table {
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 8px;
  font-size: 1em;
}
</style>
<script>
//import BarChart from '@/components/Extras/BarChart'
export default {
  name: 'ReporteLista',
  components: {
    //BarChart
  },
  data() {
    return {
      datacollection: null,
      empresa: {}
    }
  },
  props: {
    datos: {
      type: Object,
      default: function() {
        return {}
      }
    },
    catalogos: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    tiempo(orden) {
      let t = new Date(orden.fechaTerminada).getTime() - new Date(orden.fechaCreada).getTime()
      return t / (1000 * 60 * 60)
    },
    calcularCostos(d) {
      if (d.costos && d.costos.length > 0)
        return d.costos.reduce((acum, obj) => acum + parseFloat(obj.cantidad * obj.precioUnitario), 0)
      return 0
    }
  },
  async mounted() {
    this.empresa = (await Api.get('empresa'))[0] || {}
  }
}
</script>
